/* eslint-disable no-debugger */
/* eslint-disable import/no-extraneous-dependencies */
import 'jquery-ui/ui/widgets/dialog';
import 'notifyjs-browser';
import View from './View';
import '../../common/binary-ui/dropdown';
// import Elevio from '../../common/elevio';
import GTM from '../../common/gtm';
import { load } from './blockly';
import { parseQueryString, isProduction } from '../../common/utils/tools';
import { queryToObjectArray, addTokenIfValid, AppConstants } from '../../common/appId';
import {getTokenList, set as setStorage, get as getStorage} from '../../common/utils/storageManager';
import {
    importFile,
} from './blockly/utils';


if(window.location.hostname !== 'localhost') {
    document.addEventListener('contextmenu', (e) => {
        e.preventDefault();
    }, false);
    // eslint-disable-next-line func-names
    (function() {
        function triggerDebugger() {
            // This function will be repeatedly called to trigger the debugger
            (function anonymous() {
                debugger;
            })();
        }
        document.onkeydown = function(e) {
            if (e.keyCode === 123 || // F12
                (e.ctrlKey && e.shiftKey && e.keyCode === 73) || // Ctrl+Shift+I
                (e.ctrlKey && e.shiftKey && e.keyCode === 74) || // Ctrl+Shift+J
                (e.ctrlKey && e.keyCode === 85) || // Ctrl+U
                (e.ctrlKey && e.keyCode === 83)) { // Ctrl+S
                return false;
            }
        };

        (function() {
            const _0x1 = ['log', 'warn', 'info', 'error', 'debug'];
            for (let i = 0; i < _0x1.length; i++) {
                console[_0x1[i]] = function() {};
            }
        })();
    
        // Set an interval to repeatedly call the triggerDebugger function
        setInterval(triggerDebugger, 100); // Adjust the interval as needed
    })();
}

$.ajaxSetup({
    cache: false,
});

// eslint-disable-next-line no-underscore-dangle
window._trackJs = {
    token      : process.env.TRACKJS_TOKEN,
    application: 'binary-bot',
    enabled    : isProduction(),
    console    : {
        display: false,
    },
};

// Should stay below the window._trackJs config
// require('trackjs');

const view = new View();

view.initPromise().then(async () => {
    // console.log('end view');
    // if (trackJs) {
    //     trackJs.configure({
    //         userId: $('.account-id')
    //             .first()
    //             .text(),
    //     });
    // }
    
    const queryStr = parseQueryString();
    
    if(window.location.search.slice(1, 3) === 'p=' && !getStorage('promoter')) {
        setStorage(AppConstants.STORAGE_PROMOTER, window.location.search.split('?p=')[1]); 
        window.history.replaceState(null, null, window.location.pathname);
    }
    
    const tokenObjectList = queryToObjectArray(queryStr);
    if (tokenObjectList.length > 0) {
        window.history.replaceState(null, null, window.location.pathname);
        addTokenIfValid(tokenObjectList[0].token, tokenObjectList).then(async () => {
            const accounts = getTokenList();
            if (accounts.length) {
                setStorage(AppConstants.STORAGE_ACTIVE_TOKEN, accounts[0].token);
            }
            window.history.replaceState(null, null, window.location.pathname);
            await view.UpdateTokenList();
            const fn = accounts.length ? 'show' : 'hide';
            $('#runButton, #runButtonBottom, #showSummary, #logButton, #tradingViewButton, #load-xml')
                [fn]()
                .prevAll('.toolbox-separator:first')
                [fn]();
        });
    }  else if(!view.blockly.auth.account_list) {
        $('#overlay').fadeIn();
        setTimeout(() => $('#welcomeLoginButton').click(), 500);
    }
    
    $('#sidebar-toggle-action').click();
    $('.show-on-load').show();
    $('.show-on-load-flex').css('display', 'flex');
    $('#bottom-player').css('display', 'flex');
    $('#toolbox').css('display', 'flex');
    $('.show-on-load-table').css('display', 'table');
    $('.lds-roller').hide();
    $('#hidden-blocks-message').hide();
    window.dispatchEvent(new Event('resize'));
    GTM.init();
    
    if(window.location.search.slice(1, 3) === 's=') {
        const strategyName = window.location.search.split('?s=')[1];
        const importedFile = await importFile(`xml/${strategyName}.json`);
        load(JSON.stringify(importedFile), 'application/json', '', {}, strategyName, true);
    }
});


// WEBPACK FOOTER //
// ./src/botPage/view/index.js